module.exports = __webpack_public_path__ + "assets/img/index_plat_four.0a7d08e0.png";